import { Components, Theme } from "@mui/material";

export const portalDialogOverride: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backdropFilter: "blur(4px)",
      "& .MuiDialog-paper": {
        backgroundColor: theme.palette.dsBase.v100,
        borderRadius: theme.spacing(2),
        boxShadow: "none",
      },
    }),
  },
};

export const vrDialogOverride: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiBackdrop-root": {
        backdropFilter: `blur(${theme.spacing(2)})`,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      },
      "& .MuiDialog-paper": {
        backgroundColor: `${theme.palette.dsSurface.v100}90`,
        backdropFilter: `blur(${theme.spacing(1.25)})`,
        border: `1px solid ${theme.palette.dsBase.v200}10`,
        cornerShape: "squircle",
        borderRadius: theme.spacing(6),
        backgroundImage: "none",
        minWidth: "50vw",
        maxHeight: "90vh",
        maxWidth: "95vw",
        width: "auto",
        margin: theme.spacing(2),
        boxShadow: "none",
      },
    }),
  },
};

export const vrDialogTitleOverride: Components<Theme>["MuiDialogTitle"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3, 3, 1.5, 3),
    }),
  },
};

export const vrDialogContentOverride: Components<Theme>["MuiDialogContent"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
    }),
  },
};